(function (module) {
    'use strict';

    module.directive('disableDrag', () => {
        return {
            link: function (scope, element) {
                element.bind('dragenter', (e) => {
                    e.preventDefault();
                });
                element.bind('dragover', (e) => {
                    e.preventDefault();
                });
                element.bind('drop', (e) => {
                    e.preventDefault();
                });
            }
        };
    });

})(angular.module('rocket.components'));
